<template>
    <div
        v-if="!handelialogVisible"
        class="kpi-form-container"
    >
        <div class="kpi-form">
            <div class="fixed-header">
                <!-- <div class="form-header">
                    <h2>{{ formData.year }}年 {{ formData.month }}月份绩效考核表</h2>
                </div> -->
                <Header
                    :showHeaderArrow="true"
                    :showChoice="true"
                >
                    <template #title>
                        {{ formData?.year }}年{{ formData?.month }}月份{{
                            type != 0
                                ? Route.query.name
                                    ? Route.query.name + "考核表"
                                    : "考核表"
                                : "KPI模板"
                        }}
                    </template>
                    <template #extra>
                        <el-button
                            size="small"
                            type="info"
                            plain
                            style="margin-left: 12px"
                            @click="Router.push('/usage-guide')"
                        >
                            操作手册
                        </el-button>
                    </template>
                </Header>
                <!-- v-if="!dataloading && !tableData?.length && !Route.query.id" -->
                <div class="funcbtn">
                    <span class="month-buttons">
                        <span
                            v-if="!istem"
                            :class="['gotomemlastmouth', mouth === 1 ? 'mouthactive' : '']"
                            @click="rentuermouth(1)"
                        >
                            {{ getMonthDisplay(previousMonth) }}
                        </span>

                        <span
                            v-if="!istem"
                            :class="['gotomemlastmouth', mouth === 2 ? 'mouthactive' : '']"
                            @click="rentuermouth(2)"
                        >
                            {{ getMonthDisplay(currentMonth) }}
                        </span>
                        <span
                            class="nav-buttons"
                            v-if="Route.query.id && myRole !== '3' && !istem"
                        >
                            <span
                                class="gotomemlastmouth"
                                @click="goNeighbor('prev')"
                            >
                                上一个
                            </span>
                            <span
                                class="gotomemlastmouth"
                                @click="goNeighbor('next')"
                            >
                                下一个
                            </span>
                        </span>
                    </span>
                    <div>
                        <span
                            v-if="(!istem || updateCoach) && myRole !== '1'"
                            class="handel"
                            :class="{ 'is-loading': submitLoading }"
                            @click="submitKpi"
                        >
                            <template v-if="submitLoading">
                                <i class="el-icon-loading"></i>
                                Submitting...
                            </template>
                            <template v-else>Submit</template>
                        </span>
                        <!-- <span
                            v-if="!istem && myRole == '1'"
                            class="handel"
                            @click="handelall"
                        >
                            Submit
                        </span> -->
                    </div>
                </div>

                <!-- 表头 -->
                <div class="table-header">
                    <el-row
                        :gutter="16"
                        class="kpi-grid-row"
                    >
                        <el-col
                            :span="TABLE_COL_SPAN.kpi"
                            :style="getColOrderStyle('kpi')"
                        >
                            <div class="header-cell title-kpi">KPI</div>
                        </el-col>
                        <el-col
                            :span="TABLE_COL_SPAN.description"
                            :class="{ 'locked-column': keyLock }"
                            :style="getColOrderStyle('description')"
                        >
                            <div class="header-cell">
                                关键指标，每月自评时填上必要的记录说明
                                <!-- &&
                                        myRole !== '3' &&
                                        user.id !== currentuserid -->
                                <span
                                    v-if="!istem && myRole !== '3' && user.id !== currentuserid"
                                    class="lock-control-wrap"
                                >
                                    <span class="lock-compact-row">
                                        <button
                                            type="button"
                                            class="lock-label"
                                            :class="{ 'is-locked': keyLock }"
                                            @click="lockkeyword"
                                        >
                                            <el-icon class="lock-icon">
                                                <Lock v-if="keyLock" />
                                                <Unlock v-else />
                                            </el-icon>
                                            {{ keyLock ? "解锁前三列" : "锁定前三列" }}
                                        </button>
                                    </span>
                                    <el-tooltip
                                        placement="top"
                                        effect="dark"
                                    >
                                        <template #content>
                                            <div class="lock-tooltip-text">
                                                点击「锁定前三列」后，成员无法修改
                                                KPI、关键指标、分值 三列内容；
                                                <br />
                                                点击「解锁前三列」后恢复编辑。
                                            </div>
                                        </template>
                                        <span
                                            class="lock-help-trigger"
                                            @click.stop
                                        >
                                            <el-icon class="lock-help-icon">
                                                <QuestionFilled />
                                            </el-icon>
                                        </span>
                                    </el-tooltip>
                                </span>
                            </div>
                        </el-col>
                        <el-col
                            :span="TABLE_COL_SPAN.score"
                            class="kpi-col--narrow"
                            :style="getColOrderStyle('score')"
                        >
                            <div class="header-cell">分值</div>
                        </el-col>
                        <!-- 先显示自评分，再显示终评 -->

                        <el-col
                            :span="TABLE_COL_SPAN.final"
                            class="kpi-col--narrow"
                            :style="getColOrderStyle('final')"
                        >
                            <div class="header-cell">终评</div>
                        </el-col>

                        <el-col
                            :span="TABLE_COL_SPAN.superiorComment"
                            :style="getColOrderStyle('superiorComment')"
                        >
                            <div class="header-cell">上级提出的问题和建议</div>
                        </el-col>
                        <el-col
                            :span="TABLE_COL_SPAN.comment"
                            :style="getColOrderStyle('comment')"
                        >
                            <div class="header-cell">
                                被考核人自评详情（必填，否则0分；写出所扣分数和原因；附上必要的数据、记录和说明）
                            </div>
                        </el-col>
                        <el-col
                            :span="TABLE_COL_SPAN.selfScore"
                            class="kpi-col--narrow"
                            :style="getColOrderStyle('selfScore')"
                        >
                            <div class="header-cell">自评分</div>
                        </el-col>
                        <!-- <el-col :span="3">
                    <div class="header-cell">说明</div>
                </el-col> -->
                        <el-col
                            :span="TABLE_COL_SPAN.operation"
                            class="operation-col"
                            :style="getColOrderStyle('operation')"
                            v-if="istem"
                        >
                            <div
                                class="addtitle"
                                v-if="istem"
                            >
                                <el-button
                                    type="primary"
                                    :icon="Plus"
                                    circle
                                    size="small"
                                    @click="addheaderItem"
                                    class="add-button"
                                />
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <div v-if="formData">
                <!-- 考核维度区域 -->
                <div
                    class="dimension-section"
                    v-for="(dimension, dIndex) in formData?.dimensions"
                    :key="dimension.id"
                >
                    <div
                        class="dimension-header"
                        style="display: none"
                    >
                        <!-- <h3> -->
                        <!-- {{ dimension.name }} -->
                        <el-input
                            :disabled="!istem && !updateCoach"
                            v-model="dimension.name"
                            @change="calculateTotal"
                            @blur="changeheader(dimension, $event)"
                            class="maintitle"
                        ></el-input>
                        <!-- </h3> -->

                        <el-button
                            v-if="istem"
                            type="primary"
                            :icon="Plus"
                            circle
                            size="small"
                            @click="addKpiItem(dimension, dIndex)"
                            class="add-button"
                        />
                        <el-button
                            v-if="istem"
                            type="danger"
                            :icon="Delete"
                            circle
                            size="small"
                            @click="removeKpiheader(dimension, dIndex)"
                            class="add-button deleteitem-button"
                        />
                    </div>

                    <div
                        v-for="(item, iIndex) in dimension.items"
                        :key="item.id"
                        class="kpi-item"
                    >
                        <el-row
                            :gutter="16"
                            class="kpi-grid-row"
                            style="position: relative"
                        >
                            <el-col
                                :span="TABLE_COL_SPAN.kpi"
                                :style="getColOrderStyle('kpi')"
                                @dblclick="editKpi(item, item.kpi, iIndex, 'kpi')"
                            >
                                <p
                                    v-if="item.kpi && item.kpi !== '<p></p>'"
                                    class="mainp"
                                    v-html="item.kpi"
                                    @click="handleClick"
                                ></p>
                                <p v-else-if="updateCoach || !isedit"></p>
                                <p
                                    v-else
                                    class="emptycontent"
                                >
                                    <el-icon><Edit /></el-icon>
                                    <span>双击编辑内容</span>
                                </p>
                                <!-- <div
                                    v-if="
                                        item.kpi && item.kpi !== '<p></p>'
                                    "
                                    class="text-actions"
                                >
                                    <el-button
                                        link
                                        size="small"
                                        @click.stop="
                                            openPreview(item.kpi, 'KPI预览')
                                        "
                                        >查看</el-button
                                    >
                                    <el-button
                                        v-if="!updateCoach && isedit"
                                        link
                                        size="small"
                                        @click.stop="
                                            editKpi(
                                                item,
                                                item.kpi,
                                                iIndex,
                                                'kpi'
                                            )
                                        "
                                        >编辑</el-button
                                    >
                                </div> -->
                            </el-col>
                            <el-col
                                :span="TABLE_COL_SPAN.description"
                                :style="getColOrderStyle('description')"
                                @dblclick="editKpi(item, item.description, iIndex, 'description')"
                            >
                                <p
                                    v-if="item.description && item.description !== '<p></p>'"
                                    class="mainp"
                                    v-html="item.description"
                                    @click="handleClick"
                                ></p>
                                <p v-else-if="updateCoach || !isedit"></p>
                                <p
                                    v-else
                                    class="emptycontent"
                                >
                                    <el-icon><Edit /></el-icon>
                                    <span>双击编辑内容</span>
                                </p>
                                <!-- <div
                                    v-if="
                                        item.description &&
                                        item.description !== '<p></p>'
                                    "
                                    class="text-actions"
                                >
                                    <el-button
                                        link
                                        size="small"
                                        @click.stop="
                                            openPreview(
                                                item.description,
                                                '描述预览'
                                            )
                                        "
                                        >查看</el-button
                                    >
                                    <el-button
                                        v-if="!updateCoach && isedit"
                                        link
                                        size="small"
                                        @click.stop="
                                            editKpi(
                                                item,
                                                item.description,
                                                iIndex,
                                                'description'
                                            )
                                        "
                                        >编辑</el-button
                                    >
                                </div> -->
                            </el-col>
                            <el-col
                                :span="TABLE_COL_SPAN.score"
                                class="kpi-col--narrow"
                                :style="getColOrderStyle('score')"
                            >
                                <div class="score-input-wrapper">
                                    <!-- :disabled="updateCoach || !istem" -->
                                    <el-input
                                        :disabled="
                                            updateCoach || (user.id === currentuserId && keyLock)
                                        "
                                        v-model="item.score"
                                        @focus="rememberScore(item)"
                                        @change="handleScoreChange(item, dimension)"
                                        @blur="changescore(item)"
                                        @mousewheel.prevent
                                        class="score-input"
                                        :placeholder="'0'"
                                        type="number"
                                        controls-position="right"
                                    ></el-input>
                                </div>
                            </el-col>

                            <!-- 再显示终评列 -->
                            <el-col
                                :span="TABLE_COL_SPAN.final"
                                class="content-wrapper kpi-col--narrow"
                                :style="getColOrderStyle('final')"
                            >
                                <!-- @dblclick="editKpi(item, item.evaluation, iIndex, 'evaluation')" -->
                                <div class="score-input-wrapper final-score-row">
                                    <!-- @change="calculateTotal" -->
                                    <el-input
                                        :disabled="
                                            updateCoach || !isedit || user.id === currentuserId
                                        "
                                        v-model="item.evaluation"
                                        @blur="changeevaluation(item)"
                                        class="score-input"
                                        :placeholder="'0'"
                                        @mousewheel.prevent
                                        type="number"
                                        controls-position="right"
                                        :max="Number(item.score)"
                                        @input="
                                            (val) => {
                                                if (Number(val) > Number(item.score)) {
                                                    item.evaluation = item.score;
                                                }
                                            }
                                        "
                                    ></el-input>
                                    <el-tooltip
                                        v-if="canViewAiReview"
                                        :content="
                                            aiReviewLoading
                                                ? 'AI初审意见加载中'
                                                : aiReviewMap[item.id]?.reviewContent
                                                  ? '查看AI初审意见'
                                                  : 'AI初审意见暂未生成'
                                        "
                                        placement="top"
                                    >
                                        <el-button
                                            class="ai-review-trigger"
                                            :class="{
                                                'has-review': aiReviewMap[item.id]?.reviewContent
                                            }"
                                            circle
                                            :aria-label="`查看${getPlainText(item.kpi)}的AI初审意见`"
                                            @click="openAiReview(item)"
                                        >
                                            <AiRobot class="ai-robot-icon" />
                                        </el-button>
                                    </el-tooltip>
                                </div>
                            </el-col>

                            <el-col
                                :span="TABLE_COL_SPAN.superiorComment"
                                :style="getColOrderStyle('superiorComment')"
                                @dblclick="
                                    editKpi(item, item.superiorComment, iIndex, 'superiorComment')
                                "
                            >
                                <p
                                    v-if="
                                        item.superiorComment && item.superiorComment !== '<p></p>'
                                    "
                                    class="mainp"
                                    v-html="item.superiorComment"
                                    @click="handleClick"
                                ></p>
                                <p
                                    v-else-if="updateCoach || !isedit || user.id == currentuserId"
                                ></p>
                                <p
                                    v-else
                                    class="emptycontent"
                                >
                                    <el-icon><Edit /></el-icon>
                                    <span>双击编辑内容</span>
                                </p>

                                <!-- <div
                                    v-if="
                                        item.superiorComment &&
                                        item.superiorComment !== '<p></p>'
                                    "
                                    class="text-actions"
                                >
                                    <el-button
                                        link
                                        size="small"
                                        @click.stop="
                                            openPreview(
                                                item.superiorComment,
                                                '上级评价预览'
                                            )
                                        "
                                        >查看</el-button
                                    >
                                    <el-button
                                        v-if="!updateCoach && isedit"
                                        link
                                        size="small"
                                        @click.stop="
                                            editKpi(
                                                item,
                                                item.superiorComment,
                                                iIndex,
                                                'superiorComment'
                                            )
                                        "
                                        >编辑</el-button
                                    >
                                </div> -->
                            </el-col>
                            <el-col
                                :span="TABLE_COL_SPAN.comment"
                                class="content-wrapper"
                                :style="getColOrderStyle('comment')"
                                @dblclick="editKpi(item, item.comment, iIndex, 'comment')"
                            >
                                <div class="text-container">
                                    <p
                                        v-if="item.comment && item.comment !== '<p></p>'"
                                        class="content mainp"
                                        :class="{
                                            expanded: item.commentisExpanded
                                        }"
                                        v-html="item.comment"
                                        @click="handleClick"
                                        ref="(el) => setCommentRef(el, item)"
                                    ></p>
                                    <p v-else-if="updateCoach"></p>
                                    <p
                                        v-else
                                        class="emptycontent"
                                    >
                                        <el-icon><Edit /></el-icon>
                                        <span>双击编辑内容</span>
                                    </p>
                                    <!-- 底部操作行：左侧 查看/编辑，右侧 展开/收起 -->
                                    <div class="comment-bottom-row">
                                        <div
                                            v-if="item.comment && item.comment !== '<p></p>'"
                                            class="text-actions"
                                        >
                                            <el-button
                                                link
                                                size="small"
                                                @click.stop="openPreview(item.comment, '内容预览')"
                                            >
                                                查看
                                            </el-button>
                                            <el-button
                                                v-if="!updateCoach && isedit"
                                                link
                                                size="small"
                                                @click.stop="
                                                    editKpi(item, item.comment, iIndex, 'comment')
                                                "
                                            >
                                                编辑
                                            </el-button>
                                        </div>
                                        <div
                                            class="expand-button"
                                            v-if="needExpand(item)"
                                        >
                                            <el-button
                                                link
                                                type="primary"
                                                size="small"
                                                @click="commentisExpandedtoggleExpand(item)"
                                            >
                                                {{ item.commentisExpanded ? "收起" : "展开" }}
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <!-- 先显示自评分列 -->
                            <el-col
                                :span="TABLE_COL_SPAN.selfScore"
                                class="kpi-col--narrow self-score-col"
                                :style="getColOrderStyle('selfScore')"
                            >
                                <div class="score-input-wrapper">
                                    <el-input
                                        :disabled="updateCoach"
                                        v-model="item.selfScore"
                                        @change="calculateSelfTotal"
                                        @blur="changeselfScore(item)"
                                        class="score-input"
                                        :placeholder="'0'"
                                        @mousewheel.prevent
                                        type="number"
                                        controls-position="right"
                                        :max="Number(item.score)"
                                        @input="
                                            (val) => {
                                                if (Number(val) > Number(item.score)) {
                                                    item.selfScore = item.score;
                                                }
                                            }
                                        "
                                    ></el-input>
                                </div>
                            </el-col>
                            <el-col
                                :span="TABLE_COL_SPAN.operation"
                                class="operation-col"
                                :style="getColOrderStyle('operation')"
                                v-if="istem"
                            >
                                <el-button
                                    v-if="istem"
                                    type="danger"
                                    :icon="Delete"
                                    circle
                                    size="small"
                                    @click="removeKpiItem(dIndex, iIndex, item)"
                                    class="action-button"
                                />
                            </el-col>
                        </el-row>
                    </div>
                </div>

                <KpiScoreBoard
                    :suggestion="performanceScore.suggestion"
                    :selfTotalScore="performanceScore.selfTotalScore"
                    :finalScore="performanceScore.actrascore"
                    :disabled="updateCoach || !isedit"
                    @update:suggestion="
                        (v) => {
                            performanceScore.suggestion = v;
                            changesuggestion();
                        }
                    "
                />

                <!-- 签名区域 -->
                <div class="signature-section">
                    <div class="bottomsign">
                        <div class="pointersign">
                            <span>被考评人手写中文签名（月初）</span>
                            <el-button
                                v-if="!img1"
                                type="info"
                                @click="showQRCode(1)"
                            >
                                签名
                            </el-button>

                            <div
                                v-if="img1"
                                style="position: relative"
                            >
                                <img
                                    @click="opencurrentimg(img1, 1)"
                                    :src="img1"
                                    alt=""
                                />
                                <close
                                    v-if="!updateCoach"
                                    style="position: absolute; top: 0; right: 0; cursor: pointer"
                                    @click="img1 = null"
                                ></close>
                            </div>
                        </div>

                        <div class="pointersign">
                            <span>被考评人手写中文签名（月末）</span>
                            <el-button
                                v-if="!img2"
                                type="info"
                                @click="showQRCode(2)"
                            >
                                签名
                            </el-button>
                            <div
                                v-if="img2"
                                style="position: relative"
                            >
                                <img
                                    @click="opencurrentimg(img2, 2)"
                                    :src="img2"
                                    alt=""
                                />
                                <close
                                    v-if="!updateCoach"
                                    style="position: absolute; top: 0; right: 0; cursor: pointer"
                                    @click="img2 = null"
                                ></close>
                            </div>
                        </div>
                        <div class="pointersign">
                            <span>考评人手写中文签名（月末）</span>
                            <el-button
                                v-if="!img3"
                                type="info"
                                @click="showQRCode(3)"
                            >
                                签名
                            </el-button>

                            <div
                                v-if="img3"
                                style="position: relative"
                            >
                                <img
                                    @click="opencurrentimg(img3, 3)"
                                    :src="img3"
                                    alt=""
                                />
                                <close
                                    v-if="!updateCoach"
                                    style="position: absolute; top: 0; right: 0; cursor: pointer"
                                    @click="img3 = null"
                                ></close>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="empty-container"
                v-else
            >
                <el-empty
                    v-if="!dataloading && !list?.length"
                    description="No Data available"
                />
            </div>
        </div>
    </div>
    <div
        class="empty-container"
        v-else
    ></div>
    <!-- <el-dialog
        v-model="signdialogVisible"
        title="Signature"
        width="800"
    >
        <sign
            @close="closesign"
            ref="signref"
        ></sign>
    </el-dialog> -->
    <el-dialog
        v-model="cuurentImgialogVisible"
        title="Signature"
        width="800"
    >
        <div style="position: relative; text-align: center">
            <img
                :src="getCurrentDisplayImage()"
                alt=""
                style="max-width: 80%"
            />
            <el-button
                v-if="hasCodeForCurrentImage()"
                type="primary"
                :icon="Edit"
                circle
                size="small"
                style="position: absolute; top: 10px; right: 10px"
                @click="toggleCurrentImageMode()"
                :title="currentImageMode === 'signature' ? '查看二维码' : '查看签名'"
            />
        </div>
    </el-dialog>
    <el-dialog
        v-model="qrcodeDialogVisible"
        title="扫码签名"
        width="400"
        :close-on-click-modal="true"
    >
        <div style="text-align: center; padding: 20px">
            <p style="margin-bottom: 20px; color: #666">请使用手机扫描下方二维码进行签名</p>
            <img
                :src="currentQRCode"
                alt="二维码"
                style="max-width: 100%; border: 1px solid #ddd; border-radius: 8px"
            />
        </div>
    </el-dialog>
    <el-dialog
        v-model="handelialogVisible"
        width="800"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        class="custom-dialog"
    >
        <div>
            <span>
                <span
                    v-show="!dataloading && !tableData?.length && !Route.query.id"
                    :class="['gotomemlastmouth', mouth === 1 ? 'mouthactive' : '']"
                    @click="rentuermouth(1)"
                >
                    {{ getMonthDisplay(previousMonth) }}
                </span>
                <span
                    v-show="!dataloading && !tableData?.length && !Route.query.id"
                    :class="['gotomemlastmouth', mouth === 2 ? 'mouthactive' : '']"
                    @click="rentuermouth(2)"
                >
                    {{ getMonthDisplay(currentMonth) }}
                </span>
                <el-tree-select
                    value-key="id"
                    v-model="selectvalue"
                    :data="data"
                    :props="defaultProps"
                    :render-after-expand="false"
                    show-checkbox
                    check-strictly
                    style="width: 220px; margin-left: 20px"
                    @change="selectchange"
                />
            </span>
        </div>
        <div class="no-template-message">
            <i class="el-icon-warning-outline warning-icon"></i>
            <p>Coodinator暂未给你分配模板</p>
            <div class="additional-info">请耐心等待或联系你的Coodinator</div>
        </div>
    </el-dialog>

    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        v-model="dialogVisible"
        v-if="dialogVisible"
        :before-close="handleClose"
    >
        <QUILL
            :quillcontent="quillcontent"
            @changesavestate="changesavestate"
            ref="quillref"
        ></QUILL>

        <template #footer>
            <span class="dialog-footer">
                <!-- <el-button @click="dialogVisible = false">取消</el-button> -->
                <el-button
                    type="primary"
                    @click="handleSave"
                    :loading="saveloading"
                >
                    保存
                </el-button>
            </span>
        </template>
    </el-dialog>
    <!-- 富文本内容预览弹窗 -->
    <el-dialog
        v-model="previewDialogVisible"
        width="70%"
        :append-to-body="true"
        :close-on-click-modal="true"
        :title="previewTitle"
    >
        <div
            class="preview-content"
            v-html="previewContent"
        ></div>
    </el-dialog>
    <el-dialog
        v-model="aiReviewDialogVisible"
        width="560px"
        :append-to-body="true"
        :title="aiReviewDialogTitle"
    >
        <div
            v-if="currentAiReview?.reviewContent"
            class="ai-review-dialog-content"
        >
            {{ currentAiReview.reviewContent }}
        </div>
        <el-empty
            v-else
            description="AI初审意见暂未生成"
            :image-size="72"
        />
    </el-dialog>
    <!-- 图片预览弹窗 -->
    <ImagePreviewDialog
        v-model="showimagedialogVisible"
        :src="currentImageUrl"
    />
</template>

<script setup>
import { ref, onMounted, reactive, computed, onUnmounted, nextTick, watch } from "vue";
import {
    ElButton,
    ElInput,
    ElCol,
    ElInputNumber,
    ElRow,
    ElIcon,
    ElDatePicker,
    ElMessage,
    ElMessageBox,
    ElDialog,
    ElImage,
    ElButtonGroup,
    ElEmpty,
    ElTreeSelect,
    ElTooltip
} from "element-plus";
import {
    uploadTemplateAPI,
    findkpiAll,
    updatekpiAPI,
    findtemplateAll,
    updatetemplateAll,
    picAPI,
    mykpiAPI,
    addsecondModel,
    updatesecondModel,
    deletesecondModel,
    threeaddModel,
    threeupdateModel,
    threedeleteModel,
    updateKpiData,
    updateTemData,
    dataArchive,
    getdeparmentlist,
    joinlistAPI,
    updateKeyLock,
    getNextOrPreviewAPI,
    getUserKpiByDateAPI,
    submitKpiAPI,
    getKpiAiReviewAPI
} from "@/api/api";
import close from "@/components/icon/close.vue";
import AiRobot from "@/components/icon/AiRobot.vue";
import {
    Plus,
    Delete,
    Edit,
    Remove,
    Lock,
    Unlock,
    QuestionFilled
} from "@element-plus/icons-vue";
import QUILL from "@/components/qull.vue";
import sign from "@/components/sign.vue";
import ImagePreviewDialog from "@/components/ImagePreviewDialog.vue";
import KpiScoreBoard from "@/components/KpiScoreBoard.vue";
import { useImagePreview } from "@/composables/useImagePreview";
import { useCommentExpand } from "@/composables/useCommentExpand";
import { useRoute, useRouter } from "vue-router";
import { getCurrentAndPreviousMonth } from "@/utils/data";
const { currentMonth, previousMonth } = getCurrentAndPreviousMonth();
import Header from "@/components/mainHeader.vue";
const Router = useRouter();
const TABLE_COL_SPAN = Object.freeze({
    kpi: 4,
    description: 6,
    score: 1,
    final: 2,
    superiorComment: 3,
    comment: 6,
    selfScore: 1,
    operation: 1
});
// 调整列顺序时，只改这里即可；表头和内容会同步按 order 重排。
const TABLE_COL_ORDER = Object.freeze({
    kpi: 1,
    description: 2,
    score: 3,
    final: 4,
    superiorComment: 5,
    comment: 6,
    selfScore: 7,
    operation: 8
});
const getColOrderStyle = (key) => ({
    order: TABLE_COL_ORDER[key] || 99
});
const scoreBackupById = ref({});
const quillref = ref(null);
const editableDivs = ref({}); // 用于存储所有可编辑div的引用
const dialogVisible = ref(false);
const quillcontent = ref();
const saveloading = ref(false);
// 预览弹窗相关
const previewDialogVisible = ref(false);
const previewContent = ref("");
const previewTitle = ref("内容预览");
const signdialogVisible = ref(false);
const handelialogVisible = ref(false);
const img1 = ref();
const img2 = ref();
const img3 = ref();
const urlACode = ref();
const urlBCode = ref();
const urlCCode = ref();
const showCodeMode = ref({ 1: false, 2: false, 3: false }); // 控制是否显示 code 码
const Num = ref();
const cuurentImg = ref();
const cuurentImgialogVisible = ref();
const qrcodeDialogVisible = ref(false);
const currentQRCode = ref("");
const currentImageIndex = ref(0); // 当前查看的签名索引 1, 2, 3
const currentImageMode = ref("signature"); // 'signature' 或 'code'
const Route = useRoute();
const type = ref();
type.value = Route.query.type;
const currentid = ref();
const currentuserId = ref();
const currentuserid = ref();
const reviewedUserRole = ref();
const mouth = ref(1);
const select = ref();
const isshowleft = ref();
const updateCoach = ref(0);
const myRole = ref(localStorage.getItem("role"));
const istem = ref(false);
select.value = previousMonth;
isshowleft.value = Route.query.type ? true : false;
const userinfo = localStorage.getItem("userinfo");
const user = ref();
if (userinfo) {
    user.value = JSON.parse(userinfo);
}
const selectvalue = ref("");
const data = ref([]);
const keyLock = ref(0);
const aiReviewMap = ref({});
const aiReviewLoading = ref(false);
const aiReviewDialogVisible = ref(false);
const currentAiReview = ref(null);
const aiReviewDialogTitle = ref("AI初审意见");
const canViewAiReview = computed(
    () =>
        Boolean(currentid.value) &&
        type.value != 0 &&
        !istem.value &&
        [1, 2].includes(Number(reviewedUserRole.value)) &&
        myRole.value !== "3" &&
        user.value?.id !== currentuserId.value
);
const getPlainText = (html) => {
    if (!html) return "";
    const container = document.createElement("div");
    container.innerHTML = html;
    return (container.textContent || container.innerText || "").trim();
};
const openAiReview = (item) => {
    currentAiReview.value = aiReviewMap.value[item.id] || null;
    const kpiName = getPlainText(item.kpi);
    aiReviewDialogTitle.value = kpiName ? `AI初审意见 - ${kpiName}` : "AI初审意见";
    aiReviewDialogVisible.value = true;
};
const loadAiReviews = (kpiDataId) => {
    aiReviewMap.value = {};
    if (
        !kpiDataId ||
        ![1, 2].includes(Number(reviewedUserRole.value)) ||
        myRole.value === "3" ||
        user.value?.id === currentuserId.value
    ) {
        return;
    }
    aiReviewLoading.value = true;
    getKpiAiReviewAPI({ kpiDataId })
        .then((res) => {
            if (res.code === "8200" && Array.isArray(res.data)) {
                aiReviewMap.value = Object.fromEntries(
                    res.data.map((review) => [review.kpiThirdModelId, review])
                );
            }
        })
        .finally(() => {
            aiReviewLoading.value = false;
        });
};
const defaultProps = {
    children: "children",
    label: "name",
    value: "id"
};

// 从路由参数读取月份，如果没有则默认为 1（上月）
const initMonthFromRoute = () => {
    const routeMonth = Route.query.month;
    if (routeMonth) {
        mouth.value = Number(routeMonth);
        select.value = Number(routeMonth) === 1 ? previousMonth : currentMonth;
    } else {
        // 如果没有路由参数，默认显示上月，并更新路由
        mouth.value = 1;
        select.value = previousMonth;
        Router.replace({
            path: Route.path,
            query: {
                ...Route.query,
                month: 1
            }
        });
    }
};

const submitLoading = ref(false);
const submitKpi = () => {
    if (submitLoading.value) return;
    ElMessageBox.confirm("提交后将通知 Coordinator 进行审核，确认提交吗？", "提交确认", {
        confirmButtonText: "确认提交",
        cancelButtonText: "取消",
        type: "warning"
    })
        .then(() => {
            submitLoading.value = true;
            submitKpiAPI({
                kpiDataId: currentid.value
            })
                .then((res) => {
                    if (res.code === "8200") {
                        ElMessage.success("提交成功，已通知CCS");
                    }
                })
                .catch(() => {
                    ElMessage.error("提交失败，请稍后重试");
                })
                .finally(() => {
                    submitLoading.value = false;
                });
        })
        .catch(() => {});
};
// 初始化月份
initMonthFromRoute();

const getlist = () => {
    getdeparmentlist().then((res) => {
        if (res.code === "8200") {
            data.value = res.data;
            selectvalue.value = user.value?.deptId || "";
        }
    });
};

getlist();
const selectchange = (v) => {
    const formData = new FormData();
    formData.append("id", selectvalue.value ? selectvalue.value : 0);
    joinlistAPI(formData).then((res) => {
        if (res.code === "8200") {
            const currentUserInfo = JSON.parse(localStorage.getItem("userinfo"));
            currentUserInfo.deptId = selectvalue.value;
            localStorage.setItem("userinfo", JSON.stringify(currentUserInfo));
            // emit("changeorg");
            ElMessage({
                type: "success",
                message: "success"
            });
        }
    });
};
//isedit为1代表始终能够编辑，2代表是自己的kpi，只能编辑部分，为3代表所有都无法编辑
const isedit = computed(() => {
    //先判断是否是模板，是模版的话任何地方都可以编辑
    if (istem.value) {
        return true;
    } else {
        //判断是否是自己的绩效
        if (user.value.id === currentuserId.value) {
            if (!keyLock.value) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }
    // istem
    // updateCoach

    // return type.value === "template";
});
const opencurrentimg = (v, index) => {
    if (!v) return;
    cuurentImg.value = v;
    currentImageIndex.value = index;
    currentImageMode.value = "signature"; // 默认显示签名
    cuurentImgialogVisible.value = true;
};

// 获取当前弹窗显示的图片
const getCurrentDisplayImage = () => {
    if (currentImageMode.value === "code") {
        if (currentImageIndex.value === 1 && urlACode.value) {
            return urlACode.value;
        } else if (currentImageIndex.value === 2 && urlBCode.value) {
            return urlBCode.value;
        } else if (currentImageIndex.value === 3 && urlCCode.value) {
            return urlCCode.value;
        }
    }
    return cuurentImg.value;
};

// 判断当前图片是否有对应的 code
const hasCodeForCurrentImage = () => {
    if (currentImageIndex.value === 1) {
        return !!urlACode.value;
    } else if (currentImageIndex.value === 2) {
        return !!urlBCode.value;
    } else if (currentImageIndex.value === 3) {
        return !!urlCCode.value;
    }
    return false;
};

// 切换当前图片的显示模式
const toggleCurrentImageMode = () => {
    currentImageMode.value = currentImageMode.value === "signature" ? "code" : "signature";
};

const closesign = (v) => {
    let data = {
        id: currentid.value,
        date: select.value
    };
    // const Formdata = new FormData();
    // Formdata.append("file", v);
    // picAPI(Formdata).then((res) => {
    switch (Num.value) {
        case 1:
            img1.value = v;
            Object.assign(data, {
                urlA: v
            });
            break;
        case 2:
            img2.value = v;
            Object.assign(data, {
                urlB: v
            });
            break;
        case 3:
            img3.value = v;
            Object.assign(data, {
                urlC: v
            });
            break;

        default:
            break;
    }
    // });
    // const data = {
    //     id: currentid.value
    // };
    if (type.value != 0) {
        updateKpiData(data).then((res) => {});
    } else {
        updateTemData(data).then((res) => {});
    }
    signdialogVisible.value = false;
};

const opensign = (v) => {
    ElMessage.warning("模板不支持签名");
    if (!istem.value && v === 3 && user.value.id === currentuserid.value) return;
    Num.value = v;
};

// 显示二维码
const showQRCode = (index) => {
    if (index === 1 && urlACode.value) {
        currentQRCode.value = urlACode.value;
        qrcodeDialogVisible.value = true;
    } else if (index === 2 && urlBCode.value) {
        currentQRCode.value = urlBCode.value;
        qrcodeDialogVisible.value = true;
    } else if (index === 3 && urlCCode.value) {
        currentQRCode.value = urlCCode.value;
        qrcodeDialogVisible.value = true;
    } else {
        // 如果没有 code，则打开签名对话框
        opensign(index);
    }
};
// 控制对话框显示状态
const { showimagedialogVisible, currentImageUrl, handleClick } = useImagePreview();

// 表单数据
const formData = ref();
//绩效得分与绩效等级
const performanceScore = ref({
    totalscore: "100",
    actrascore: "85",
    actranumber: "1",
    actralevel: "B",
    suggestion: ""
});
const changeactranumber = () => {
    const data = {
        id: currentid.value,
        actranumber: performanceScore.value.actranumber
    };
    if (type.value != 0) {
        updateKpiData(data).then((res) => {});
    } else {
        updateTemData(data).then((res) => {});
    }
};
// const changeactrascore = () => {
//     const data = {
//         id: currentid.value,
//         actrascore: performanceScore.value.actrascore
//     };
//     if (type.value != 0) {
//         updateKpiData(data).then((res) => {});
//     } else {
//         updateTemData(data).then((res) => {});
//     }
// };
const changeactralevel = () => {
    const data = {
        id: currentid.value,
        actralevel: performanceScore.value.actralevel
    };
    if (type.value != 0) {
        updateKpiData(data).then((res) => {});
    } else {
        updateTemData(data).then((res) => {});
    }
};
const changesuggestion = () => {
    const data = {
        id: currentid.value,
        suggestion: performanceScore.value.suggestion
    };
    if (type.value != 0) {
        updateKpiData(data).then((res) => {});
    } else {
        updateTemData(data).then((res) => {});
    }
};
const changeheader = (v, e) => {
    console.log(v);
    console.log(e.target.value);
    const data = {
        id: v.id,
        name: v.name
    };
    updatesecondModel(data).then((res) => {
        if (res.code === "8200") {
        }
    });
};
//查询所有数据
const getData = () => {
    // const data = {
    //     id: Route.query.id,
    //     type: Route.query.type
    // };
    // //这里是获取模板的数据
    // findtemplateAll(data).then((res) => {
    //     if (res.code === "8200") {
    //         formData.value = res.data;
    //         img1.value = res.data.urlA;
    //         img2.value = res.data.urlB;
    //         img3.value = res.data.urlC;

    //         calculateTotal();
    //     } else {
    //         ElMessage.error("获取模板数据失败");
    //     }
    // });
    const ID = Route.query.id;
    if (!ID) {
        mykpiAPI({ date: select.value })
            .then((res) => {
                if (res && res.data) {
                    performanceScore.value.actrascore = res.data.actrascore;
                    performanceScore.value.actranumber = res.data.actranumber;
                    performanceScore.value.suggestion = res.data.suggestion;
                    performanceScore.value.actralevel = res.data.actralevel;
                    handelialogVisible.value = false;
                    currentid.value = res.data.id;
                    keyLock.value = res.data.keyLock;
                    currentuserId.value = res.data.userId;
                    currentuserid.value = res.data.userId;
                    reviewedUserRole.value = res.data.roleId;
                    updateCoach.value = res.data.updateCoach;
                    istem.value = res.data.template;
                    formData.value = res.data.content;
                    img1.value = res.data.urlA;
                    img2.value = res.data.urlB;
                    img3.value = res.data.urlC;
                    urlACode.value = res.data.urlACode;
                    urlBCode.value = res.data.urlBCode;
                    urlCCode.value = res.data.urlCCode;
                    if (formData.value) {
                        // 根据当前表单里的月份设置 mouth 默认值
                        if (formData.value.month) {
                            const m = Number(formData.value.month);
                            const prevM = Number(previousMonth.split("-")[1]);
                            const currM = Number(currentMonth.split("-")[1]);
                            if (m === prevM) {
                                mouth.value = 1;
                            } else if (m === currM) {
                                mouth.value = 2;
                            }
                        }

                        calculateTotal();
                        calculateSelfTotal(); // 添加这行
                        // 数据加载完成后，检查所有评论项是否需要展开按钮
                        nextTick(() => {
                            checkAllCommentsNeedExpand();
                        });
                    }
                } else {
                    handelialogVisible.value = true;
                }
            })
            .finally((res) => {
                // dataloading.value = false;
            });
    } else {
        if (type.value != 0) {
            findkpiAll({}, ID).then((res) => {
                if (res.code === "8200") {
                    performanceScore.value.actrascore = res.data.actrascore;
                    performanceScore.value.actranumber = res.data.actranumber;
                    performanceScore.value.suggestion = res.data.suggestion;
                    performanceScore.value.actralevel = res.data.actralevel;
                    currentid.value = res.data.id;
                    currentuserId.value = res.data.userId;
                    currentuserid.value = res.data.userId;
                    updateCoach.value = res.data.updateCoach;
                    istem.value = res.data.template;
                    keyLock.value = res.data.keyLock;
                    reviewedUserRole.value = res.data.roleId;
                    formData.value = res.data.content;
                    loadAiReviews(res.data.id);
                    img1.value = res.data.urlA;
                    img2.value = res.data.urlB;
                    img3.value = res.data.urlC;
                    urlACode.value = res.data.urlACode;
                    urlBCode.value = res.data.urlBCode;
                    urlCCode.value = res.data.urlCCode;
                    if (formData.value) {
                        if (formData.value.month) {
                            const m = Number(formData.value.month);
                            const prevM = Number(previousMonth.split("-")[1]);
                            const currM = Number(currentMonth.split("-")[1]);
                            let newMouthValue = mouth.value;
                            if (m === prevM) {
                                newMouthValue = 1;
                            } else if (m === currM) {
                                newMouthValue = 2;
                            }
                            // 如果月份值发生变化，更新 mouth 和路由参数
                            if (newMouthValue !== mouth.value) {
                                mouth.value = newMouthValue;
                                select.value = newMouthValue === 1 ? previousMonth : currentMonth;
                                Router.replace({
                                    path: Route.path,
                                    query: {
                                        ...Route.query,
                                        month: newMouthValue
                                    }
                                });
                            }
                        }

                        calculateTotal();
                        calculateSelfTotal(); // 添加这行
                        // 数据加载完成后，检查所有评论项是否需要展开按钮
                        nextTick(() => {
                            checkAllCommentsNeedExpand();
                        });
                    }
                }
            });
        } else {
            findtemplateAll({ id: ID, type: type.value || 0 })
                .then((res) => {
                    if (res.code === "8200") {
                        performanceScore.value.actrascore = res.data.actrascore;
                        performanceScore.value.actranumber = res.data.actranumber;
                        performanceScore.value.suggestion = res.data.suggestion;
                        performanceScore.value.actralevel = res.data.actralevel;
                        currentid.value = res.data.id;
                        currentuserId.value = res.data.userId;
                        currentuserid.value = res.data.userId;
                        updateCoach.value = res.data.updateCoach;
                        istem.value = res.data.template;
                        formData.value = res.data.content;
                        img1.value = res.data.urlA;
                        img2.value = res.data.urlB;
                        img3.value = res.data.urlC;
                        urlACode.value = res.data.urlACode;
                        urlBCode.value = res.data.urlBCode;
                        urlCCode.value = res.data.urlCCode;
                        if (formData.value) {
                            if (formData.value.month) {
                                const m = Number(formData.value.month);
                                const prevM = Number(previousMonth.split("-")[1]);
                                const currM = Number(currentMonth.split("-")[1]);
                                if (m === prevM) {
                                    mouth.value = 1;
                                } else if (m === currM) {
                                    mouth.value = 2;
                                }
                            }

                            calculateTotal();
                            calculateSelfTotal(); // 添加这行
                        }
                    }
                })
                .finally((res) => {
                    // dataloading.value = false;
                });
        }
    }
};
getData();
// 当前记录所属年月字符串，例如 2026-03
const currentDateStr = computed(() => {
    if (formData.value?.year && formData.value?.month) {
        const m = String(formData.value.month).padStart(2, "0");
        return `${formData.value.year}-${m}`;
    }
    return select.value;
});

// 点击时获取上一条或下一条 KPI，并跳转
const fetchNeighborKpi = (direction) => {
    if (!currentid.value || type.value == 0) return;

    const params = {
        date: currentDateStr.value,
        kpiDataId: currentid.value
    };

    getNextOrPreviewAPI(params).then((res) => {
        if (res.code !== "8200" || !res.data) {
            ElMessage.error("获取数据失败");
            return;
        }
        const data = res.data;
        const isPrev = direction === "prev";
        const targetId = isPrev ? data.previewDataId : data.nextDataId;
        const targetName = isPrev ? data.previewUserName : data.nextUserName;

        if (!targetId) {
            ElMessage.warning(isPrev ? "已经是第一条了" : "已经是最后一条了");
            return;
        }

        Router.replace({
            path: "/detail",
            query: {
                ...Route.query,
                id: targetId,
                name: targetName || Route.query.name,
                type: 1
            }
        });
    });
};
// 格式化月份显示：将 "2026-02" 格式转换为 "2月"
const getMonthDisplay = (monthStr) => {
    if (!monthStr) return "";
    const month = parseInt(monthStr.split("-")[1]);
    return `${month}月`;
};

const rentuermouth = (v) => {
    // 记录切换前的月份和选择值，方便无数据时还原
    const prevMouth = mouth.value;
    const prevSelect = select.value;

    mouth.value = v;
    if (v === 1) {
        select.value = previousMonth;
    } else {
        select.value = currentMonth;
    }

    // 如果是查看某个 KPI 数据（type != 0 且有 id），通过后端接口按月份查找对应记录
    if (type.value != 0 && Route.query.id) {
        getUserKpiByDateAPI({
            date: select.value,
            userId: currentuserId.value
        }).then((res) => {
            if (res.code !== "8200" || !res.data) {
                ElMessage.warning("该月份暂无数据");
                // 还原选择的月份
                mouth.value = prevMouth;
                select.value = prevSelect;
                // 还原路由参数
                Router.replace({
                    path: Route.path,
                    query: {
                        ...Route.query,
                        month: prevMouth
                    }
                });
                return;
            }
            const data = res.data;
            const targetId = res.data;
            const targetName = data.name || data.userName || data.nickname || Route.query.name;

            if (!targetId) {
                ElMessage.warning("该月份暂无数据");
                mouth.value = prevMouth;
                select.value = prevSelect;
                // 还原路由参数
                Router.replace({
                    path: Route.path,
                    query: {
                        ...Route.query,
                        month: prevMouth
                    }
                });
                return;
            }

            Router.replace({
                path: "/detail",
                query: {
                    ...Route.query,
                    id: targetId,
                    name: targetName,
                    type: 1,
                    month: v // 更新月份参数
                }
            });
        });
    } else {
        // 模板或"我的KPI"等场景，仍然用原来的按 date 查询逻辑
        // 更新路由参数
        Router.replace({
            path: Route.path,
            query: {
                ...Route.query,
                month: v
            }
        });
        getData();
    }
};

// 跳转到上一条 / 下一条 KPI
const goNeighbor = (direction) => {
    fetchNeighborKpi(direction);
};

// 计算总分
const calculateTotal = () => {
    let total = 0;
    formData.value?.dimensions?.forEach((dimension) => {
        dimension.items?.forEach((item) => {
            total += Number(item.score) || 0;
        });
    });

    // 更新总分
    if (formData.value) {
        formData.value.totalScore = total;
    }

    // 更新绩效分数相关信息
    performanceScore.value.totalscore = total;

    // 如果有实际得分，根据实际得分计算绩效等级和系数
    if (performanceScore.value.actrascore) {
        updatePerformanceLevel();
    }
};

const getScoreTotal = () => {
    let total = 0;
    formData.value?.dimensions?.forEach((dimension) => {
        dimension.items?.forEach((item) => {
            total += Number(item.score) || 0;
        });
    });
    return total;
};

const getDimensionScoreTotal = (dimension) => {
    let total = 0;
    dimension?.items?.forEach((item) => {
        total += Number(item.score) || 0;
    });
    return total;
};

const getDimensionScoreLimit = (dimension) => {
    const direct = Number(dimension?.totalScore);
    if (Number.isFinite(direct) && direct > 0) return direct;

    // 兜底：后端 totalScore 为空时，尝试从名称里解析 "xx分"
    const name = String(dimension?.name || "");
    const m = name.match(/(\d+)\s*分/);
    if (m) return Number(m[1]);
    return null;
};

const rememberScore = (item) => {
    if (!item?.id) return;
    scoreBackupById.value[item.id] = Number(item.score) || 0;
};

const handleScoreChange = (item, dimension) => {
    const limit = getDimensionScoreLimit(dimension);
    if (limit == null) {
        scoreBackupById.value[item.id] = Number(item.score) || 0;
        calculateTotal();
        return;
    }

    const total = getDimensionScoreTotal(dimension);
    if (total > limit) {
        const backup = scoreBackupById.value[item.id];
        item.score = backup ?? 0;
        calculateTotal();
        ElMessage.warning(
            `${dimension?.name || "当前维度"} 的分值总分不能超过 ${limit}，已恢复原值`
        );
        return;
    }
    scoreBackupById.value[item.id] = Number(item.score) || 0;
    calculateTotal();
};

// 计算自评总分
const calculateSelfTotal = () => {
    let selfTotal = 0;
    formData.value?.dimensions?.forEach((dimension) => {
        dimension.items?.forEach((item) => {
            selfTotal += Number(item.selfScore) || 0;
        });
    });
    let actrascore = 0;
    formData.value?.dimensions?.forEach((dimension) => {
        dimension.items?.forEach((item) => {
            actrascore += Number(item.evaluation) || 0;
        });
    });
    // 可以在这里添加一个自评总分字段
    performanceScore.value.selfTotalScore = selfTotal;
    performanceScore.value.actrascore = actrascore;
    updatePerformanceLevel();
};

// 根据实际得分更新绩效等级和绩效系数
const updatePerformanceLevel = () => {
    const score = Number(performanceScore.value.actrascore);

    // 根据分数设置绩效等级和系数
    if (score >= 90) {
        performanceScore.value.actralevel = "A";
        performanceScore.value.actranumber = "1.2";
    } else if (score >= 70) {
        performanceScore.value.actralevel = "B";
        performanceScore.value.actranumber = "1.0";
    } else if (score >= 60) {
        performanceScore.value.actralevel = "C";
        performanceScore.value.actranumber = "0.8";
    } else {
        performanceScore.value.actralevel = "D";
        performanceScore.value.actranumber = "0";
    }

    // 保存更新后的数据
    savePerformanceData();
};

// 保存绩效数据到服务器
const savePerformanceData = () => {
    console.log(666666);

    const data = {
        id: currentid.value,
        actrascore: performanceScore.value.actrascore
        // actranumber: performanceScore.value.actranumber,
        // actralevel: performanceScore.value.actralevel
    };

    if (type.value != 0) {
        updateKpiData(data).then(() => {});
    } else {
        updateTemData(data).then(() => {});
    }
};

// 修改实际得分时自动更新绩效等级和系数
const changeactrascore = () => {
    updatePerformanceLevel();
};
// 计算总分
// const calculateTotal = () => {
//     let total = 0;
//     formData.value?.dimensions?.forEach((dimension) => {
//         dimension.items?.forEach((item) => {
//             total += Number(item.score) || 0;
//         });
//     });
//     // if (formData.value && formData.value.totalScore) {
//     formData.value.totalScore = total;
//     // }
// };
const changescore = (v) => {
    const data = {
        id: v.id,
        score: v.score
    };
    threeupdateModel(data).then((res) => {
        calculateSelfTotal(); // 添加这行
    });
};
const changeevaluation = (v) => {
    const data = {
        id: v.id,
        evaluation: v.evaluation
    };
    threeupdateModel(data).then((res) => {
        calculateSelfTotal(); // 添加这行
    });
};
const changeselfScore = (v) => {
    const data = {
        id: v.id,
        selfScore: v.selfScore
    };
    threeupdateModel(data).then((res) => {
        calculateSelfTotal(); // 添加这行
    });
};
// 添加考核项
const addKpiItem = (item, dimensionIndex) => {
    const dimension = formData.value.dimensions[dimensionIndex];
    const newItemId = `${dimension.id}-${dimension.items?.length + 1}`;
    const data = {
        templateId: Route.query.id,
        secondModelId: item.id
    };
    threeaddModel(data).then((res) => {
        if (res.code === "8200") {
            const newItem = {
                id: res.data,
                kpi: "",
                description: "",
                score: 0,
                selfScore: 0, // 新增自评得分字段
                evaluation: "",
                superiorComment: "",
                comment: "",
                explanation: "",
                evaluationisExpanded: false,
                commentisExpanded: false
            };
            if (!dimension.items) {
                dimension.items = [];
            }
            dimension.items.push(newItem);
            ElMessage.success("添加考核项成功");
        }
    });
};
const addheaderItem = () => {
    const data = {
        templateId: Route.query.id,
        firstModelId: formData.value.id
    };
    addsecondModel(data).then((res) => {
        if (res.code === "8200") {
            const newDimension = {
                id: res.data,
                name: "",
                totalScore: 0,
                items: []
            };
            formData.value.dimensions.push(newDimension);
        }
    });
    const newDimensionId = `D-${formData.value.dimensions?.length + 1}`;
};
// 删除考核项
const removeKpiItem = (dimensionIndex, itemIndex, item) => {
    ElMessageBox.confirm("确定要删除这个考核项吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
    })
        .then(() => {
            threedeleteModel({ id: item.id }).then((res) => {
                if (res.code === "8200") {
                    formData.value.dimensions[dimensionIndex].items.splice(itemIndex, 1);
                    calculateTotal();
                    ElMessage.success("删除成功");
                }
            });
        })
        .catch(() => {
            ElMessage.info("已取消删除");
        });
};
// 删除考核项
const removeKpiheader = (item, itemIndex) => {
    ElMessageBox.confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
    })
        .then(() => {
            deletesecondModel({ id: item.id }).then((res) => {
                if (res.code === "8200") {
                    formData.value.dimensions.splice(itemIndex, 1);
                    calculateTotal();
                    ElMessage.success("删除成功");
                }
            });
        })
        .catch(() => {
            ElMessage.info("已取消删除");
        });
};

// 组件挂载时计算总分
onMounted(() => {
    // if (formData.value) {
    //     calculateTotal();
    // }
});
onUnmounted(() => {});
const storeContent = ref();
// 添加新的 ref 来存储当前编辑的项目信息
const currentEditItem = ref(null);
const currentEditField = ref("");
const editKpi = (item, content, index, type) => {
    console.log(type);

    //判断普通成员的kpi
    if (user.value.id === currentuserId.value) {
        // 前三列（kpi、description、score）跟随 keyLock 锁定状态
        if (["kpi", "description"].includes(type)) {
            if (keyLock.value) {
                ElMessage.warning("前三列已锁定，无法编辑");
                return;
            }
        }
        // superiorComment 始终不允许普通成员编辑
        if (type === "superiorComment") {
            ElMessage.warning("你没有权限编辑该字段");
            return;
        }
    }
    if (updateCoach.value) return;
    currentEditItem.value = item;
    currentEditField.value = type;
    // 根据content判断当前编辑的是哪个字段
    console.log(currentEditField.value);

    quillcontent.value = content;
    storeContent.value = content;
    dialogVisible.value = true;
};
const openPreview = (content, title) => {
    previewContent.value = content || "<p>暂无内容</p>";
    previewTitle.value = title || "内容预览";
    previewDialogVisible.value = true;
};
const handleSave = () => {
    saveloading.value = true;
    quillref.value.describesure();
    dialogVisible.value = false;
};
const handleClose = () => {
    // 优先使用子组件提供的 isModified 判断是否有真正编辑
    let changed = false;
    try {
        if (quillref.value && typeof quillref.value.isModified === "function") {
            changed = quillref.value.isModified();
        } else {
            // 兜底：对比进入编辑时的内容和当前内容
            let current = "";
            if (quillref.value && typeof quillref.value.getContent === "function") {
                current = quillref.value.getContent();
            } else {
                current = quillcontent.value || "";
            }
            const origin = storeContent.value || "";
            changed = current !== origin;
        }
    } catch (e) {
        changed = false;
    }

    // 如果内容没有变化，直接关闭，不需要二次确认
    if (!changed) {
        dialogVisible.value = false;
        return;
    }

    // 有内容变更时，才弹出二次确认
    ElMessageBox.confirm("编辑的内容都将丢失，确定要关闭么？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
    })
        .then(() => {
            dialogVisible.value = false;
        })
        .catch(() => {});
};
const changesavestate = (v) => {
    console.log(currentEditItem.value, currentEditField.value);
    // 确保有当前编辑项
    if (currentEditItem.value && currentEditField.value) {
        const data = {
            id: currentEditItem.value.id,
            [currentEditField.value]: v
        };
        threeupdateModel(data)
            .then((res) => {
                if (res.code === "8200") {
                    currentEditItem.value[currentEditField.value] = v;
                    ElMessage.success("保存成功");
                } else {
                    ElMessage.error("保存失败");
                }
            })
            .finally(() => {
                saveloading.value = false;
                // 清空当前编辑项信息
                currentEditItem.value = null;
                currentEditField.value = "";
                saveloading.value = false;
            });
        // 更新对应字段的内容
    }
};
// 存储评论元素的引用，用于判断是否需要展开按钮
// 评论展开/收起逻辑
const { setCommentRef, needExpand, checkAllCommentsNeedExpand, commentisExpandedtoggleExpand } =
    useCommentExpand();

const evaluationisExpandedtoggleExpand = (item) => {
    item.evaluationisExpanded = !item.evaluationisExpanded;
};

const handelall = () => {
    ElMessageBox.confirm("封存后该KPI将不可再编辑，确定要封存吗？", "封存确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
    })
        .then(() => {
            dataArchive({ kpiDataId: currentid.value }).then((res) => {
                if (res.code === "8200") {
                    ElMessage.success("封存成功");
                }
            });
        })
        .catch(() => {
            // 用户取消操作
        });
};
const lockkeyword = () => {
    const ids = [Route.query.id, "00000"];
    const formData = new FormData();
    ids.forEach((id) => {
        formData.append("kpiDataIdList", id);
    });
    formData.append("keyLock", String(keyLock.value ? 0 : 1));
    updateKeyLock(formData).then((res) => {
        if (res.code === "8200") {
            keyLock.value = keyLock.value === 0 ? 1 : 0;
        }
    });
};

// 监听路由 id 变化，切换上一条/下一条时重新拉取数据
watch(
    () => Route.query.id,
    (newVal, oldVal) => {
        if (newVal && newVal !== oldVal) {
            getData();
        }
    }
);

// 监听路由变化，当月份参数变化时更新数据
watch(
    () => Route.query.month,
    (newMonth) => {
        if (newMonth) {
            const monthNum = Number(newMonth);
            if (monthNum !== mouth.value) {
                mouth.value = monthNum;
                select.value = monthNum === 1 ? previousMonth : currentMonth;
                // 如果只是月份变化，且不是通过 rentuermouth 触发的，需要重新获取数据
                // 但这里要避免重复调用，因为 rentuermouth 已经会调用 getData
                // 所以这里只在路由直接变化时（比如浏览器前进后退）才调用
                if (!Route.query.id || type.value === 0) {
                    getData();
                }
            }
        }
    }
);
</script>
<style lang="scss" scoped>
.kpi-form {
    // padding: 0px 20px 20px 20px;
    background-color: #fff;

    .form-header {
        text-align: center;
        margin-bottom: 20px;

        h2 {
            color: #303133;
            margin: 0;
        }
    }

    .table-header {
        background-color: #ffffff;
        padding: 14px 16px;
        border: 1px solid #e8eaed;
        border-bottom: 2px solid #e2e6ea;
        border-radius: 10px 10px 0 0;
        overflow: visible;

        .header-cell {
            line-height: 1.5;
            font-weight: 600;
            color: #000;
            font-size: 14px;
            word-break: break-word;
        }
        .title-kpi {
            padding-left: 20px;
        }
    }

    .dimension-section {
        border: 1px solid #e8eaed;
        margin-bottom: 16px;
        border-radius: 12px;
        overflow: hidden;
        background: white;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        transition: box-shadow 0.2s ease;

        &:hover {
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.07);
        }

        .dimension-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 20px;
            background: linear-gradient(to right, #f8fafb, #ffffff);
            border-bottom: 1px solid #f0f2f5;
            position: relative;
            h3 {
                margin: 0;
                font-size: 16px;
                color: #111827;
            }

            .add-button {
                margin-left: auto;
                position: absolute;
                right: 40px;
            }
            .deleteitem-button {
                right: 10px;
            }
        }

        .kpi-item {
            padding: 16px;
            border-bottom: 1px solid #f3f4f6;
            transition: background 0.15s ease;

            &:last-child {
                border-bottom: none;
            }

            &:hover {
                background: #fafbfc;
            }

            .el-row {
                align-items: center;
            }

            .el-input-number {
                width: 100%;
            }
        }
    }
}

.kpi-grid-row {
    min-width: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.kpi-col--narrow {
    .header-cell {
        text-align: center;
    }
}

.operation-col {
    display: flex;
    justify-content: center;
    align-items: center;
}

.comment-input {
    //  width: 90%;
    min-height: 100px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    outline: none;
    position: relative;
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 8px;
    box-sizing: border-box;
    overflow-y: auto;

    /* 基础样式 */
    padding: 10px;
    line-height: 1.5;
    border: 1px solid #ccc;

    /* 禁用连字符 */
    hyphens: none;
}

/* 添加占位符样式 */
.comment-input:empty:before {
    content: attr(placeholder);
    color: #999;
    pointer-events: none;
}
.comment-input:empty:before {
    content: attr(placeholder);
    color: #999;
}
.score-input-wrapper {
    padding: 4px 0;

    .score-input {
        :deep(.el-input__wrapper) {
            background-color: #fafbfc;
            border-radius: 8px;
            box-shadow: none;
            border: 1.5px solid #e5e7eb;
            transition: all 0.2s ease;

            &:hover {
                border-color: #93c5fd;
                background: white;
            }

            &.is-focus {
                border-color: #3b82f6;
                background-color: #fff;
                box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
            }
        }

        :deep(.el-input__inner) {
            height: 34px;
            padding: 0;
            font-size: 15px;
            font-weight: 600;
            color: #000;
            text-align: center;

            &::placeholder {
                color: #d1d5db;
                font-weight: 400;
            }
        }

        :deep(.el-input__suffix) {
            color: #9ca3af;
            font-size: 12px;
            padding-right: 0;
        }
    }
}

.final-score-row {
    display: flex;
    align-items: center;
    gap: 6px;

    .score-input {
        min-width: 0;
        flex: 1;
    }
}

.ai-review-trigger {
    flex: 0 0 auto;
    width: 36px;
    height: 36px;
    color: #7c3aed;
    border-color: #c4b5fd;
    background: #f5f3ff;
    box-shadow: 0 2px 6px rgba(124, 58, 237, 0.18);

    .ai-robot-icon {
        width: 21px;
        height: 21px;
    }

    &:hover,
    &:focus {
        color: #6d28d9;
        border-color: #a78bfa;
        background: #ede9fe;
    }
}

.ai-review-trigger.has-review {
    color: #ffffff;
    border-color: #7c3aed;
    background: #7c3aed;
    box-shadow: 0 2px 8px rgba(124, 58, 237, 0.35);

    &:hover,
    &:focus {
        color: #ffffff;
        border-color: #6d28d9;
        background: #6d28d9;
    }
}

.ai-review-dialog-content {
    color: #334155;
    line-height: 1.8;
    white-space: pre-wrap;
    word-break: break-word;
}

// 输入框获得焦点时的样式
.score-input:focus-within {
    :deep(.el-input__wrapper) {
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    }
}

// 禁用输入框的上下箭头
.score-input :deep(.el-input__inner::-webkit-outer-spin-button),
.score-input :deep(.el-input__inner::-webkit-inner-spin-button) {
    -webkit-appearance: none;
    margin: 0;
}

// Firefox
.score-input :deep(.el-input__inner[type="number"]) {
    -moz-appearance: textfield;
}
.action-button {
    position: static;
}
.content-wrapper {
    position: relative;

    .text-container {
        position: relative;

        .content {
            line-height: 1.7;
            word-wrap: break-word;
            transition: all 0.2s ease;
            position: relative;
            color: #000;
            font-size: 14px;

            :deep(img) {
                max-width: 100%;
                height: auto;
                display: block;
                margin: 8px 0;
                border-radius: 6px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
                transition: transform 0.2s ease;

                &:hover {
                    transform: scale(1.01);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
                }
            }

            &.expanded {
                display: block;
                max-height: none !important;
                -webkit-line-clamp: none !important;
            }

            &:not(.expanded) {
                display: -webkit-box;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .expand-button {
            text-align: right;

            .el-button {
                padding: 4px 10px;
                font-size: 12px;
                font-weight: 500;
                border-radius: 4px;
                transition: all 0.15s ease;

                &:hover {
                    color: #2563eb;
                    background-color: #eff6ff;
                }
            }
        }
    }
}
.text-actions {
    display: flex;
    gap: 6px;
}
.text-actions :deep(.el-button.is-link) {
    padding: 2px 6px;
    font-size: 12px;
    font-weight: 500;
    color: #3b82f6;
    border-radius: 4px;
    transition: all 0.15s ease;
}
.text-actions :deep(.el-button.is-link:hover) {
    background: #eff6ff;
    color: #2563eb;
}
.comment-bottom-row {
    margin-top: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.preview-content {
    height: calc(80vh - 100px);
    overflow-y: auto;
    padding: 12px 4px 4px 4px;
    font-size: 16px;
    line-height: 1.7;

    :deep(img) {
        max-width: 100%;
        height: auto;
        display: block;
        margin: 8px 0;
        border-radius: 4px;
    }
}
.mainp {
    min-height: 40px !important;
    word-wrap: break-word;
    line-height: 1.7;
    font-size: 14px;
    color: #000;

    :deep(img) {
        max-width: 100%;
        height: auto;
        display: block;
        margin: 8px 0;
        border-radius: 6px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
}
.kpi-form-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.fixed-header {
    position: sticky;
    top: 0;
    background-color: #f0f2f5;
    z-index: 10;
    padding-top: 12px;
}

.scrollable-content {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
}
.kpi-form-container {
    height: calc(100vh - 60px);
}
.scrollable-content {
    padding: 0 16px;
}
:deep .el-input__wrapper {
    padding: 0;
}
// // 渐变遮罩
// .content:not(.expanded)::after {
//     content: "";
//     position: absolute;
//     bottom: 0;
//     left: 0;
//     width: 100%;
//     height: 24px;
//     background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
//     pointer-events: none;
// }
.total-score {
    font-size: 18px;
    font-weight: 600;
    margin-top: 10px;
    display: flex;
    :deep .el-input__wrapper {
        padding: 0 10px !important;
        border: none;
        box-shadow: none;
        font-size: 18px;
        font-weight: 600;
    }
}
.pointersign {
    display: flex;
    align-items: center;

    span {
        min-width: 230px;
    }
    img {
        width: 150px;
        height: 30px;
        border: 1px solid #ccc;
        cursor: pointer;
    }
    .code-toggle-btn {
        position: absolute;
        top: 0;
        left: 0;
        padding: 4px 8px;
        font-size: 12px;
        z-index: 10;
        background-color: rgba(64, 158, 255, 0.9);
        border: none;
        color: white;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
            background-color: rgba(64, 158, 255, 1);
        }
    }
}
.bottomsign {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    width: 85%;
}
.bottoninput {
    width: 50px;
}
.buttoncomment {
    display: flex;
    justify-content: space-between;
    gap: 14px;
    align-items: flex-start;
    background: #fff;
    border-radius: 12px;
    padding: 14px;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
    border: 1px solid #edf1f7;

    .topnum {
        width: 34%;
        min-width: 320px;
        background: #f9fafc;
        border: 1px solid #ebeff5;
        border-radius: 10px;
        padding: 8px;
    }

    .commentinput {
        width: 66%;
        :deep(.el-textarea) {
            display: block;
        }
        :deep(.el-textarea__inner) {
            min-height: 120px !important;
            border-radius: 10px;
            padding: 12px 14px;
            line-height: 1.6;
            border: 1px solid #dfe5ef;
            box-shadow: none;
            transition:
                border-color 0.2s ease,
                box-shadow 0.2s ease;
        }
        :deep(.el-textarea__inner:focus) {
            border-color: #cfd7e6;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.08);
        }
    }

    .score-board {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 8px;
    }

    .score-card {
        border: 1px solid #e6ebf2;
        border-radius: 9px;
        background: #fff;
        padding: 10px 12px;
        min-height: 96px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .score-title {
        font-size: 12px;
        color: #7a8597;
        margin-bottom: 8px;
    }

    .score-number {
        font-size: 32px;
        font-weight: 700;
        line-height: 1;
        color: #1f2a3d;
        letter-spacing: 0.3px;
    }
}

@media (max-width: 1200px) {
    .buttoncomment {
        flex-direction: column;
        align-items: stretch;

        .topnum,
        .commentinput {
            width: 100%;
            min-width: 0;
        }

        .score-board {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }
    }
}

@media (max-width: 768px) {
    .buttoncomment .score-board {
        grid-template-columns: 1fr;
    }
}
.maintitle {
    width: 220px;

    :deep(.el-input__wrapper) {
        padding: 4px 8px;
        transition: all 0.2s ease;
        border-radius: 6px;
        background: transparent;
        box-shadow: none;
        border-bottom: 2px solid transparent;

        &:not(:focus-within) {
            padding-left: 0;
            padding-right: 0;
        }

        &:hover {
            background-color: #f3f4f6;
            border-bottom: 2px solid #d1d5db;
        }

        &:focus-within {
            background-color: #fff;
            border-bottom: 2px solid #3b82f6;
        }

        .el-input__inner {
            font-size: 16px;
            font-weight: 700;
            color: #000;
            transition: color 0.2s ease;

            &::placeholder {
                color: #9ca3af;
                font-weight: 400;
            }
        }
    }
}
.table-header {
    position: relative;
    .addtitle {
        position: static;
        display: flex;
        justify-content: center;
    }
}
.emptycontent {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 16px;
    color: #9ca3af;
    font-size: 13px;
    border: 1.5px dashed #e5e7eb;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    min-height: 44px;
    gap: 6px;
}

.emptycontent:hover {
    border-color: #93c5fd;
    color: #3b82f6;
    background-color: #eff6ff;
}

.emptycontent .el-icon {
    margin-right: 4px;
    font-size: 15px;
}
.gotomemlastmouth {
    cursor: pointer;
    margin-left: 20px;
}
.mouthactive {
    background-color: #e6e6e6;
    border-radius: 10px;
    padding: 5px;
    font-weight: 800;
}
.funcbtn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

/* 左侧：月份 + 上/下一个 */
.month-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
}

/* 统一的顶部小按钮样式（月份 + 上/下一个） */
.gotomemlastmouth {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 7px 16px;
    border-radius: 8px;
    cursor: pointer;
    background: #f7f8fa;
    color: #000;
    transition: all 0.2s ease;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid #e8eaed;
    user-select: none;
}

.gotomemlastmouth:hover {
    border-color: #409eff;
    background: #eef5ff;
    color: #409eff;
}

.mouthactive {
    background: #409eff;
    color: white;
    border-color: #409eff;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

/* 提交按钮样式 */
.handel {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 9px 20px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    color: white;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
    font-weight: 600;
    margin-right: 10px;
    box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
}

.handel:hover {
    background: linear-gradient(135deg, #16a34a, #15803d);
    box-shadow: 0 4px 14px rgba(34, 197, 94, 0.4);
    transform: translateY(-1px);
}
:deep .el-input.is-disabled .el-input__wrapper {
    box-shadow: none !important;
}
:deep .el-input.is-disabled .el-input__inner {
    color: #000;
    -webkit-text-fill-color: #000;
}

:deep .el-dialog {
    margin: 20px auto !important;
    height: auto;
    max-height: 90vh;
    max-width: 90vw;
}

:deep(.el-dialog__header) {
    padding: 10px;
    margin: 0;
}

:deep(.el-dialog__body) {
    padding: 0;
    height: calc(90vh - 100px);
    overflow: hidden;
}

:deep(.el-dialog__headerbtn) {
    top: 10px;
}

:deep(.el-button-group) {
    display: flex;
    gap: 1px;
}

:deep(.el-button) {
    // padding: 5px 12px;
    // height: 32px;
}

:deep(.el-button:hover) {
    // background-color: #f5f7fa;
}
.custom-dialog {
    /* 弹窗整体样式 */
    :deep(.el-dialog) {
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        overflow: hidden;
    }

    /* 弹窗标题样式 */
    :deep(.el-dialog__header) {
        background: #409eff;
        padding: 20px;
        margin: 0;
    }

    :deep(.el-dialog__title) {
        color: white;
        font-size: 20px;
        font-weight: 600;
    }

    /* 弹窗内容区域样式 */
    :deep(.el-dialog__body) {
        padding: 40px 20px;
    }
}

.no-template-message {
    text-align: center;
    padding: 30px 0;
}

.warning-icon {
    font-size: 48px;
    color: #e6a23c;
    margin-bottom: 20px;
}

.no-template-message p {
    font-size: 24px;
    color: #303133;
    margin: 15px 0;
    font-weight: 500;
}

.additional-info {
    color: #909399;
    font-size: 16px;
    margin-top: 10px;
}

/* 添加一些动画效果 */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.custom-dialog {
    animation: fadeIn 0.3s ease-out;
}
.fronticon {
    width: 16px;
    /* height: 20px; */
    cursor: pointer;
    margin-left: 20px;
    &:hover {
        background-color: #d8d8d8;
    }
}
.empty-container {
    // width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    padding: 20px;
}

.empty-icon {
    color: #909399;
}

:deep(.el-empty__description) {
    margin-top: 20px;
    font-size: 14px;
    color: #909399;
}

:deep(.el-empty__bottom) {
    margin-top: 20px;
}
.locked-column {
    position: relative;
}

// .locked-column::after {
//     content: "";
//     position: absolute;
//     inset: 2px -8px -2px 0;
//     background: linear-gradient(
//         135deg,
//         rgba(248, 113, 113, 0.08),
//         rgba(248, 113, 113, 0.03)
//     );
//     pointer-events: none;
//     border-radius: 8px;
// }

.lock-control-wrap {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 6px;
    margin-left: 8px;
    vertical-align: middle;
}

.lock-compact-row {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
}

.lock-status-chip {
    font-size: 11px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 999px;
    line-height: 1.4;
    white-space: nowrap;
    background: #ecfdf3;
    color: #15803d;
    border: 1px solid #bbf7d0;
}

.lock-status-chip.is-locked {
    background: #fff7ed;
    color: #c2410c;
    border-color: #fed7aa;
}

.lock-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 500;
    padding: 3px 10px;
    border-radius: 999px;
    border: 1px solid #22c55e;
    color: #16a34a;
    background: #ecfdf3;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: inherit;
    line-height: 1.35;
}

.lock-label.is-locked {
    border-color: #f97316;
    color: #ea580c;
    background: #fff7ed;
}

.lock-label:hover {
    box-shadow: 0 0 0 1px rgba(148, 163, 184, 0.4);
    transform: translateY(-0.5px);
}

.lock-icon {
    width: 14px;
    height: 14px;
}

.lock-help-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: help;
    color: #94a3b8;
    border-radius: 50%;
    padding: 2px;
    transition: color 0.2s ease;
}

.lock-help-trigger:hover {
    color: #64748b;
}

.lock-help-icon {
    width: 15px;
    height: 15px;
}

.lock-tooltip-text {
    max-width: 280px;
    line-height: 1.55;
    font-size: 13px;
}

/* ================= 打印样式优化 ================= */
@media print {
    /* 取消页面高度限制，避免内容被截断 */
    .kpi-form-container {
        height: auto !important;
        padding: 0 20px !important;
        background: #fff !important;
    }

    .kpi-form {
        box-shadow: none !important;
        background-color: #fff !important;
        padding: 0 0 20px 0 !important;
    }

    /* 取消粘性头部，打印时按正常文档流显示 */
    .fixed-header {
        position: static !important;
        box-shadow: none !important;
        background: #fff !important;
    }

    /* 让滚动区域在打印时展开为完整内容 */
    .scrollable-content {
        overflow: visible !important;
        height: auto !important;
        padding: 0 20px !important;
    }

    /* 避免签名区域被分页截断，并在打印时显示签名 */
    .signature-section {
        display: block !important;
        page-break-inside: avoid;
        break-inside: avoid;
    }

    /* 签名图片在打印时完整显示 */
    .signature-section img {
        max-width: 100% !important;
        height: auto !important;
    }
}
</style>

<style lang="scss" scoped>
.kpi-form-container {
    background: #f0f2f5;
    padding: 16px 20px;
    min-height: 100vh;
}

/* 主容器 */
.kpi-form {
}

/* Header */
.fixed-header {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #f0f2f5;
    padding-bottom: 4px;
}

/* 功能按钮栏 */
.funcbtn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 0;
    padding: 10px 16px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

/* 月份按钮 */
.gotomemlastmouth {
    background: #f7f8fa;
    border: 1px solid #e8eaed;
    padding: 7px 16px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
    font-weight: 500;
    color: #000;
    user-select: none;
}

.gotomemlastmouth:hover {
    border-color: #409eff;
    background: #eef5ff;
    color: #409eff;
}

.gotomemlastmouth:active {
    transform: scale(0.97);
}

.mouthactive {
    background: #409eff;
    color: white;
    border-color: #409eff;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.mouthactive:hover {
    background: #2d8cf0;
    border-color: #2d8cf0;
    color: white;
}

/* 提交按钮 */
.handel {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    padding: 9px 20px;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.3px;
    box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
    transition: all 0.2s ease;
    user-select: none;
}

.handel:hover {
    background: linear-gradient(135deg, #16a34a, #15803d);
    box-shadow: 0 4px 14px rgba(34, 197, 94, 0.4);
    transform: translateY(-1px);
}

.handel:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(34, 197, 94, 0.3);
}

.handel.is-loading {
    opacity: 0.7;
    cursor: not-allowed;
    pointer-events: none;
    transform: none;
}

/* 表头 */
.table-header {
    background: white;
    border-radius: 10px 10px 0 0;
    padding: 14px 16px;
    border: 1px solid #e8eaed;
    border-bottom: 2px solid #e2e6ea;

    .header-cell {
        font-size: 14px;
        font-weight: 600;
        color: #000;
        line-height: 1.5;
    }
}

/* KPI 维度卡片 */
.dimension-section {
    background: white;
    border-radius: 12px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    border: 1px solid #e8eaed;
    overflow: hidden;
    transition: box-shadow 0.2s ease;

    &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.07);
    }
}

/* 维度标题 */
.dimension-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 20px;
    background: linear-gradient(to right, #f8fafb, #ffffff);
    border-bottom: 1px solid #f0f2f5;
}

/* KPI 行 */
.kpi-item {
    padding: 16px 16px;
    border-top: 1px solid #f3f4f6;
    transition: background 0.15s ease;
    position: relative;

    &:first-child {
        border-top: none;
    }

    &:hover {
        background: #fafbfc;
    }
}

/* 文本内容 */
.mainp {
    line-height: 1.7;
    font-size: 14px;
    color: #000;
    word-break: break-word;
}

/* 空内容提示 */
.emptycontent {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 16px;
    color: #9ca3af;
    font-size: 13px;
    border: 1.5px dashed #e5e7eb;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    min-height: 44px;
    gap: 6px;

    &:hover {
        border-color: #93c5fd;
        color: #3b82f6;
        background: #eff6ff;
    }
}

/* 分值输入框 */
.score-input-wrapper {
    :deep(.el-input__wrapper) {
        border-radius: 8px;
        border: 1.5px solid #e5e7eb;
        background: #fafbfc;
        box-shadow: none;
        transition: all 0.2s ease;
        padding: 2px 8px;
    }

    :deep(.el-input__wrapper:hover) {
        border-color: #93c5fd;
        background: white;
    }

    :deep(.el-input__wrapper.is-focus) {
        border-color: #3b82f6;
        background: white;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    :deep(.el-input__inner) {
        text-align: center;
        font-weight: 600;
        font-size: 15px;
        color: #1f2937;
    }
}

/* 展开按钮 */
.expand-button {
    .el-button {
        padding: 4px 8px;
        font-size: 12px;
        border-radius: 4px;
    }
}

/* 签名区域 */
.signature-section {
    margin-top: 16px;
    padding: 20px;
    border-radius: 12px;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    border: 1px solid #e8eaed;
    display: none;
}

.bottomsign {
    display: flex;
    justify-content: space-between;
    gap: 20px;
}

.pointersign {
    display: flex;
    align-items: center;
    gap: 12px;

    span {
        font-size: 14px;
        color: #000;
        white-space: nowrap;
    }

    img {
        border-radius: 6px;
        border: 1px solid #e5e7eb;
        cursor: pointer;
        transition: transform 0.2s;

        &:hover {
            transform: scale(1.03);
        }
    }
}

/* 空状态 */
.empty-container {
    background: white;
    border-radius: 12px;
    padding: 60px 40px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    border: 1px solid #e8eaed;
    text-align: center;
}

p {
    color: #000;
}

/* 维度标题输入框 */
.maintitle {
    :deep(.el-input__wrapper) {
        background: transparent;
        box-shadow: none;
        border-bottom: 2px solid transparent;
        border-radius: 4px;
        padding: 4px 8px;
        transition: all 0.2s ease;

        &:hover {
            background: #f3f4f6;
            border-bottom-color: #d1d5db;
        }

        &:focus-within {
            background: white;
            border-bottom-color: #3b82f6;
        }

        .el-input__inner {
            font-size: 16px;
            font-weight: 700;
            color: #111827;
        }
    }
}
</style>
